import {
  arrow,
  FloatingArrow,
  useFloating,
  autoUpdate,
  offset,
  shift,
  Placement,
} from "@floating-ui/react";
import { ReactNode, useRef } from "react";
import { z } from "zod";

import { useStorage } from "@smart/itops-hooks-dom";
import { Button } from "@smart/itops-sb-design-system-dom";

const dismissedSchema = z.boolean().optional();

type FeatureInfoProps = {
  featureName: string;
  info: string | ReactNode;
  children: ReactNode;
  placement?: Placement;
  hideInfoPopup?: boolean;
};

export const FeatureInfo = ({
  children,
  info,
  featureName,
  placement,
  hideInfoPopup,
}: FeatureInfoProps) => {
  const [isDismissed, setIsDismissed] = useStorage({
    defaultValue: undefined,
    key: featureName,
    schema: dismissedSchema,
    storage: "local",
  });

  const arrowRef = useRef(null);
  const { refs, floatingStyles, context } = useFloating({
    open: !isDismissed,
    placement,
    whileElementsMounted: autoUpdate,
    middleware: [
      shift({ padding: 10 }),
      arrow({
        element: arrowRef,
      }),
      offset(15),
    ],
  });

  return (
    <div className="w-full" ref={refs.setReference}>
      {!isDismissed && !hideInfoPopup && (
        <div
          className="flex flex-col gap-4 max-w-[35rem] p-8 rounded-2xl z-20 text-white bg-orange-400 rounded"
          ref={refs.setFloating}
          style={floatingStyles}
        >
          <div className="text-ui">{info}</div>
          <div className="flex justify-end">
            <Button
              variant="secondaryDefault"
              text="Got it"
              onClick={() => setIsDismissed(true)}
              size="small"
            />
          </div>
          <FloatingArrow
            className="fill-orange-400"
            ref={arrowRef}
            context={context}
            width={20}
            height={10}
          />
        </div>
      )}
      {children}
    </div>
  );
};
